"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _AutoComplete = _interopRequireDefault(require("./AutoComplete"));
var _default = exports.default = {
  components: {
    AutoComplete: _AutoComplete.default
  },
  props: ['network', 'buffer', 'sidebarState'],
  data() {
    return {
      self: this,
      pluginUiSections: _GlobalApi.default.singleton().aboutBufferPlugins,
      closedSections: {},
      inviteNick: ''
    };
  },
  computed: {
    b() {
      return this.buffer || {};
    },
    formattedTopic() {
      let blocks = (0, _MessageParser.default)(this.b.topic || '', {
        extras: false
      });
      let content = (0, _Html.default)(blocks);
      return content;
    },
    highlights() {
      // Tap into buffer.message_count to force vuejs to update this function when
      // it changes
      /* eslint-disable no-unused-vars */
      let tmp = this.buffer.message_count;
      return this.buffer.getMessages().filter(m => m.isHighlight).filter(m => m.type !== 'traffic').filter(m => m.type !== 'topic').filter(m => m.type !== 'mode').filter(m => m.html).sort((a, b) => b.time - a.time);
    },
    areWeAnOp() {
      return this.buffer.isUserAnOp(this.network.nick);
    },
    invitableUsers() {
      const wantedBuffer = userBuffer => userBuffer.buffer.name === this.buffer.name;
      return Object.values(this.network.users).filter(user => !Object.values(user.buffers).find(wantedBuffer)).map(user => ({
        text: user.nick
      }));
    }
  },
  methods: {
    toggleSection(section) {
      this.$set(this.closedSections, section, !this.closedSections[section]);
    },
    inviteUser() {
      if (!this.inviteNick) {
        return;
      }
      this.network.ircClient.invite(this.buffer.name, this.inviteNick);
      this.inviteNick = '';
    },
    inviteSelected(value, item) {
      this.inviteNick = value;
    },
    inviteKeyDown(event) {
      if (event.key === 'Tab') {
        this.$refs.autocomplete.selectCurrentItem();
        return;
      }
      this.$refs.autocomplete.handleOnKeyDown(event);
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SidebarAboutBuffer"]
window._kiwi_exports.components.SidebarAboutBuffer = exports.default ? exports.default : exports;
